import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MWidgetsModule } from '@mining/ui/widgets';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzOutletModule } from 'ng-zorro-antd/core/outlet';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { MFieldItemComponent } from './field-item.compontent';
import { MFieldPickerComponent } from './field-picker.component';

@NgModule({
  imports: [CommonModule, MWidgetsModule, NzOutletModule, NzToolTipModule, NzInputModule, NzButtonModule, FormsModule, NzIconModule],
  exports: [MFieldPickerComponent, MFieldItemComponent],
  declarations: [MFieldPickerComponent, MFieldItemComponent]
})
export class MFieldPickerModule {}
